import { Component, OnInit, EventEmitter, ViewChild, Input, HostListener } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, Subject, of } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DateObject, DocumentModel, Document_Upload, Document_Upload_File, SCREEN_CONTROL, SCREEN_RESPONSE, ScreenResponseModel } from 'src/app/models/common';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import * as $ from 'jquery';
import { serviceConstants } from 'src/app/constants/service.constants';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { FileService } from 'src/app/services/file.service';
import { IDeactivateComponent } from 'src/app/services/common/deactivate-guard.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-grants-document-upload-sponsorship',
  templateUrl: './grants-document-upload-sponsorship.component.html',
  styleUrls: ['./grants-document-upload-sponsorship.component.scss']
})
export class GrantsDocumentUploadSponsorshipComponent implements OnInit,IDeactivateComponent {

  formFields;
  uploadedFiles = ["Attachement one", "Attachment two", "Attachment three"];
  // File upload
  formData: FormData;
  files: any[];
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  permission: string;
  docuemntUploadForm = new UntypedFormGroup({});
  document_attach_list: Document_Upload[] = [];
  @Input() rowid: string = "";
  ScreenMode: string = "";
  applicationID: any;
  now = new Date();
  isUploadValid: boolean = true;
  public validationMessage: string = "";
  FeatureID: string = "079437C409B6A503E0638C00000A789D";
  IsUptoDateList = [];
  action: Subject<any> = new Subject();
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  GrantsUploadFiles: Document_Upload_File[];
  ProfileUptoDateValue: any;
  appid: string;
  operations: any = [];
  staticformFields: any;
  _TransactionID: string;

  IsFormToched = false;
  isDateModified: boolean = false;
  Full_Date: DateObject;
  tooltipValue: string;
  submittedresponse: SCREEN_RESPONSE[] = [];
  isSubmitVisible : boolean = false;
  disableSave: boolean = false;
  Grantsapp: any;
  createdUser: any;
  ScreenSubmitStatus: boolean = false;
  user : any;
  submitStatus:boolean = false;
  Id : string;
  status : number = 0;
  GeneralInformationFields: any;
  Application_Type_ID: string = "";
  ScreenName: string = '';

  constructor(
    private summaryService: GrantsSummaryService,
    public datepipe: DatePipe,
    public commonService: CommonService,
    public datashare: GrantsDatashareService,
    private router: Router,
    private modalService: NgbModal,
    private header: HeadService,
    public grantsDatashare: GrantsDatashareService,
    private userService: UserService,
    public fileService: FileService,
  ) {
    this.files = [];
    this.uploadInput = new EventEmitter<any>();
  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.applicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
        this.IsUptoDateList = this.staticformFields["IS_UPTO_DATE"].GROUP_VALUES_LIST;
      });
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    this.IsFormToched = true;
  }

  ngOnInit() {
    if (this.Application_Type_ID == null || this.Application_Type_ID == undefined || this.Application_Type_ID == "") {
      this.grantsDatashare.Application_Type_ID.subscribe(x => {
        this.Application_Type_ID = x;
      });
    }
    this.GetParentScreenFieldsConfigControls('GSP01');
    //this.NavigateToGenInfo();
    this.applicationID = this.commonService.appId;
    //this.getStaticFiledsData('SCR-034');
    //this.applicationID = this.appid;
    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    if (this.applicationID == "" || this.applicationID == null || this.applicationID == undefined) {
      this.applicationID = "0";
    }

    this.Grantsapp = this.commonService.getGrantsApp();
    this.user = this.userService.getUserDetais();
    this.grantsDatashare.GrantApplicationID.subscribe(x => {
      this.applicationID = x;
    });  

    this.GetScreenConfigControls('SCR-034');

    this.IsFormToched = false;

    if(!this.isSubmitVisible){
      this.disableSave = false;
    }
    
    this.permission = this.commonService.getPagePermission("GSP04").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("GSP04").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
          clearInterval(intervalId);
          this.setFormPermissions();
        }
      }, 1000);
    }
    else {
      this.setFormPermissions();
    }
    this.getFeatureDocuments();
    //this.FetchProfileUptodate();
  }

  ngOnChanges() {

    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    if (this.applicationID == "" || this.applicationID == null || this.applicationID == undefined) {
      this.applicationID = "0";
    }
    this.getFeatureDocuments();
  }

  canExit() {
    if (this.IsFormToched) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

  getFeatureDocuments() {
    let model = new DocumentModel();
    model.Featureid = this.FeatureID;
    model.Rowid = this.rowid;
    model.Appid = this.applicationID;
    this.summaryService.getFeatureDocuments(model).subscribe(summary => {
      this.document_attach_list = summary;
      this._TransactionID = this.document_attach_list[0].TRANSACTION_ID;
    });
  }

  private setFormPermissions() {
    this.ScreenMode = this.permission;
    if (this.permission == "view") {
      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.permission = this.permission;
        this.extendedForm.ScreenMode = this.permission;
      }
      this.docuemntUploadForm.disable();
    }

    if (this.permission == "view") {
      this.docuemntUploadForm.disable();
      this.operations = [];
    }
    else {
      this.operations = [
        {
          name: 'saveDocumentUploads', type: 'submit', callback: this.saveDocumentUploads, self: this
        }
      ];
    }
  }


  FetchProfileUptodate() {
    this.summaryService.FetchProfileUptoDate(this.applicationID).subscribe(response => {
      if (response.Data.IS_PROFILE_UPTO_DATE != null) {
        this.docuemntUploadForm.controls['IS_UPTO_DATE'].setValue(response.Data.IS_PROFILE_UPTO_DATE);
        this.ProfileUptoDateValue = response.Data.IS_PROFILE_UPTO_DATE;
      }
      this.extendedForm.rowid = response.Data.ID;
      this.extendedForm.getResponse();
    })
  }

  // uploadchange(event, ques: Document_Upload): void {
  //   // let Flag = true;
  //   let Isexe = false;
  //   let Is5oMB = false;

  //   let hasMultipleFiles = false;
  //   let Duplicate_File_List = [];

  //   if (ques.UploadFiles == undefined || ques.UploadFiles == null)
  //     ques.UploadFiles = [];
  //   for (let i = 0; i < event.target.files.length; i++) {
  //     let uploadFile = new Document_Upload_File();
  //     var file = event.target.files[i].name;
  //     var ext = file.match(/\.([^\.]+)$/)[1];
  //     var filesize = event.target.files[i].size;

  //     if (file != null && (ext == 'exe')) {
  //       Isexe = true;
  //     }
  //     else if (file != null && ((filesize > 52428800))) {
  //       Is5oMB = true;
  //     }
  //     else {
  //       let uploadFile = new Document_Upload_File();
  //       uploadFile.ID = this.commonService.getUniqueId();
  //       uploadFile.DOCUMENT_NAME = event.target.files[i].name;
  //       uploadFile.File = event.target.files[i];
  //       uploadFile.Status = "Add";
  //       uploadFile.UploadedDate = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY');
  //       uploadFile.Document_Url = "";
  //       uploadFile.FIELD_ID = "";

  //       //if(uploadFile.DOCUMENT_NAME)


  //       uploadFile.SEQUENCE_NO = 0;
  //       // uploadFile.TRANSACTION_ID = this.applicationID;
  //       let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
  //       if (hasValue.length > 0) {
  //         hasMultipleFiles = true;
  //         Duplicate_File_List.push(uploadFile.DOCUMENT_NAME);
  //       } else {
  //         if (ques.IsMultipleDocuments) {
  //           ques.ApplicationID = this.applicationID;
  //           ques.DOCUMENT_TYPE_ID = ques.DocumentTypeID;
  //           ques.SEQUENCE_NO = 0;
  //           ques.UploadFiles.push(uploadFile);
  //         } else {
  //           ques.UploadFiles = [];
  //           ques.UploadFiles.push(uploadFile);
  //         }
  //       }
  //     }
  //   }
  //   if (hasMultipleFiles) {
  //     this.commonService.ValidationBanner("File already exists with " + Duplicate_File_List.join(', ') + ". Please update the unique file name");
  //   }
  //   if (Is5oMB && Isexe) {
  //     this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
  //   }

  //   else if (Is5oMB) {
  //     this.commonService.ValidationBanner("Accepts maximum file size 50MB");
  //   }

  //   else if (Isexe) {
  //     this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
  //   }
  //   else {

  //   }



  // }

  validateControls(): boolean {
    let isValid = true;
    let message = "";

    if(this.Grantsapp?.STATUS >= 2){
      this.staticformFields.forEach((item) => {
        if (item.IS_MANDATORY && item.IS_Dependent_Enabled == true && item.IS_Dependent_Display == true) {
          switch (item.CONTROL) {
            case 1:
            case 2:
            case 3:
            case 5:
            case 4:
            case 11:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 10:
                if (!(item.ControlValue) || (item.ControlValue != null && item.ControlValue.length == 0)) {
                  $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                  $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                  message += `Please enter ${item.LABEL} <br/>`;
                  isValid = false;
                }
              break;
            case 6:
              let seletedItem = "";
              for (let c = 0; c < item.SourceItems.length; c++) {
                if (item.SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = item.SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + item.SourceItems[c].value;
                }
              }
              item.ControlValue = seletedItem;
              if(!item.ControlValue)
              {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            
            case 7:
              if (!item.ControlValue) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 8:
              if (item.UploadFiles != null && item.UploadFiles != undefined && item.UploadFiles.length == 0) {
                $("#dynmcId" + item["ID"]).addClass("ng-touched ng-invalid validate-error");
                $("#dynmcId" + item["ID"]).removeClass("ng-untouched ng-valid");
                message += `Please enter ${item.LABEL} <br/>`;
                isValid = false;
              }
              break;
            case 9:
              break;
          }
        }
      });

      if (isValid) {
        let inactiveValueControls = this.commonService.checkInactiveRecordState(this.staticformFields);
        if (inactiveValueControls && inactiveValueControls.length > 0) {
          isValid = false;
          let dataMsg = inactiveValueControls.join("</br>");
          this.commonService.ValidationBanner(dataMsg);
        }
      }
    }  
    else {
      // Check at least one field value exists
      isValid = this.commonService.checkHasSingleControlValue(this.staticformFields);
      if (!isValid) {
        message += `Please enter at least one field. <br/>`;
      }
    }
      if (!isValid)
        this.commonService.ValidationBanner(message);
    return isValid;
  }


  public saveDocumentUploads(SaveType:string) {

    if (this.validateControls()) {
      if (this.staticformFields != null && this.staticformFields.length > 0) {
        for (let i = 0; i < this.staticformFields.length; i++) {
          switch (this.staticformFields[i].CONTROL) {
            case 6:
              let seletedItem = "";
              for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                if (this.staticformFields[i].SourceItems[c].Checked == true) {
                  if (seletedItem == "")
                    seletedItem = this.staticformFields[i].SourceItems[c].value;
                  else
                    seletedItem = seletedItem + "," + this.staticformFields[i].SourceItems[c].value;
                }
              }
              this.staticformFields[i].ANSWER = seletedItem;
              break;
            case 8:
              this.staticformFields[i].UploadedDocuments = [];
              if (this.staticformFields[i].UploadFiles) {
                for (let j = 0; j < this.staticformFields[i].UploadFiles.length; j++) {
                  if (this.staticformFields[i].UploadFiles[j].Status == "Add" || this.staticformFields[i].UploadFiles[j].Status == "Delete") {
                    this.staticformFields[i].UploadedDocuments.push(this.staticformFields[i].UploadFiles[j]);
                  }
                }
                this.staticformFields[i].ANSWER = null;
                this.staticformFields[i].ControlValue = null;
              }
              break;
            case 10:
              let SelectedValues = this.staticformFields[i].ControlValue;
              if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
                this.staticformFields[i].ANSWER = SelectedValues.join(",");
              }
              else {
                this.staticformFields[i].ANSWER = "";
              }
              this.staticformFields[i].SUBFIELDNAME = "";
              //this.staticformFields[i].ControlValue = null;
              break;
            case 5:
              let controlanswer = this.staticformFields[i].ControlValue;
              if (controlanswer != null && controlanswer != "" && controlanswer != undefined) {
                let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
                this.staticformFields[i].ANSWER = formd;
              }
              else {
                this.staticformFields[i].ANSWER = controlanswer;
              }
              break;
            default:
              this.staticformFields[i].ANSWER = this.staticformFields[i].ControlValue;
              break;
          }
        }
        let uploadData = new FormData();
        let FinalControls=_.cloneDeep(this.staticformFields);
        FinalControls.forEach((item)=>{
          switch (item.CONTROL) {
            case 10:
              item.ControlValue=null;
              break;
          }
        });
        uploadData.append("ScreenControlsData", JSON.stringify(FinalControls));
        uploadData.append("ModuleID", "4");

        if (SaveType == "Save") {
          if(this.isSubmitVisible == true && this.Grantsapp?.STATUS > 1 && this.ScreenSubmitStatus == false) {
            uploadData.append("SUBMIT_STATUS", "0");

          } 
          else {
            uploadData.append("SUBMIT_STATUS", "1");
          }
        } else{
          uploadData.append("SUBMIT_STATUS", "1");

        }

        if(this.applicationID){
        if (this.applicationID == "" || this.applicationID == undefined) {
          uploadData.append("AppId", this.applicationID);
          this.summaryService.saveGRTUploadDocDocuments(uploadData).subscribe((result) => {
            this.IsFormToched = false;
            this.applicationID = result["TransactionID"];
            if (result.Status === 0) {
              this.getScreenDataEdit();
              this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
            }
            else {
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        else {
          uploadData.append("AppId", this.applicationID);
          this.summaryService.saveGRTUploadDocDocuments(uploadData).subscribe((result) => {
            this.IsFormToched = false;
            if (result.Status === 0) {
              if (result.ErrorCode === "NOCHANGES") {
                this.getScreenDataEdit();
                this.commonService.ValidationBanner(result.Message);
              }
              else {
                this.getScreenDataEdit();
                this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
              }
            }
            else {
              this.getScreenDataEdit();
              this.commonService.ValidationBanner(result.Message);
            }
          });
        }
        }
        else{
          this.SaveSponsorShip_GM_APP().subscribe((result) => {
            if (result != null && result.Status == 0) {
              this.applicationID = result["TransactionID"];
              this.grantsDatashare.setGrantApplicationID(this.applicationID);
              uploadData.append("AppId", this.applicationID);
              this.summaryService.saveGRTUploadDocDocuments(uploadData).subscribe((summary) => {
                this.IsFormToched = false;
                if (summary.Status === 0) {
                  this.commonService.SuccessBanner(this.ScreenName + " saved successfully");
                  this.commonService.refreshApplicationPage(this.applicationID, 'grants');
                }
                else {
                  this.commonService.ValidationBanner(summary.Message);
                }
              });
            }
            else{
              this.commonService.ValidationBanner(result.Message);
            }
          })
        }
      }
    }
  }

  _upLoadFiles: any;
  // DeleteUpload(file, listindex, index): void {

  //   file.Status = "Delete";
  //   this.commonService.CheckIsFileIsRefereancedInReviw(file.ID).subscribe((x) => {
  //     if (x["Status"] == 2 && x["Data"] == false) {
  //       this.commonService.ValidationBanner(x["Message"]);
  //     }
  //     else {
  //       this.document_attach_list.forEach((ele, index) => {
  //         if (ele.UploadFiles[listindex][index].ID == file.ID) {
  //           this._upLoadFiles = ele.UploadFiles[listindex];
  //           this._upLoadFiles.splice(index, 1);
  //         }
  //       })
  //     }
  //   });

  // }

  OnNotesOuts(notesvalue, index) {
    this.document_attach_list.forEach((ele, node) => {
      if (node == index) {
        ele.NOTES = notesvalue;
      }
    })
  }

  DownloadFile(fileID) {
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  // ViewFile(fileID, fileName) {
  //   this.commonService.previewFile(fileID, fileName, "med");
  // }

  profileUptodateClick(value) {
    this.document_attach_list[0].IS_UPTO_DATE = value;
    this.ProfileUptoDateValue = value;
  }

  NavigateToGenInfo() {
    this.appid = this.commonService.appId;
    let ModuleMenu = this.commonService.getModuleMenu();
    if (this.appid == null || this.appid == undefined || this.appid == "") {
      const modalRefBud2 = this.modalService.open(MessageBoxComponent, {});
      modalRefBud2.componentInstance.Content = { heading: '', content: { heading: '', description: 'Please save General information details to navigate to Document Uploads', operation: { hasConfirm: false } } };
      modalRefBud2.result.then((result) => {
        this.router.navigate(['/home/grants/my-applications/application-ext/:' + this.appid + '/genInformsponsorship'],
          { skipLocationChange: true, queryParams: { id: this.appid, app_ext: true, module: "grants", submodule: ModuleMenu.module, screen_type: "my-applications" } })
      });
      return false;
    }
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.applicationID, this.applicationID,(ScreenData) => {
      this.staticformFields = ScreenData["SCREEN_CONTROL"];
      this.ScreenName = ScreenData.NAME;
      this.getScreenDataEdit();
      if(this.Grantsapp?.STATUS > 1 ){
        this.isSubmitVisible = ScreenData.HAS_SAVE_SUBMIT == 1 ? true :false;       
      }  
    });
  }

  singleonChange($event, question) {
    this.IsFormToched = true;
    this.UpdateParentChildDetails(question);
    this.ApplyConditions($event, question, "Y");
  }

  ApplyConditions($event, question, makeNull) {
    let value = $event.value;
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      if (item.Mapped_Control_Value == value) {
        item.ConditionsList.forEach((otemCon) => {
          switch (otemCon.Mapped_Condtion) {
            case "1": //display
              if (displayControlIDS.length == 0) {
                displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disCntrIds && disCntrIds.length > 0) {
                  disCntrIds.forEach((id) => {
                    if (!displayControlIDS.includes(id)) {
                      displayControlIDS.push(id);
                    }
                  })
                }
              }

              break;
            case "2": //enabled
              if (enableControlIDS.length == 0) {
                enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (enableCntrIds && enableCntrIds.length > 0) {
                  enableCntrIds.forEach((id) => {
                    if (!enableControlIDS.includes(id)) {
                      enableControlIDS.push(id);
                    }
                  })
                }
              }
              break;
            case "3": //hide
              if (hideControlIDS.length == 0) {
                hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (hideCntrIds && hideCntrIds.length > 0) {
                  hideCntrIds.forEach((id) => {
                    if (!hideControlIDS.includes(id)) {
                      hideControlIDS.push(id);
                    }
                  })
                }
              }

              break;

            case "4": //disabled
              if (disbledControlIDS.length == 0) {
                disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              }
              else {
                let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
                if (disableCntrIds && disableCntrIds.length > 0) {
                  disableCntrIds.forEach((id) => {
                    if (!disbledControlIDS.includes(id)) {
                      disbledControlIDS.push(id);
                    }
                  })
                }
              }
              break;
          }

        });
      }
    })
    //default
    if (value != "") {
      this.staticformFields.forEach((con) => {

        if (displayControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (hideControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Display = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (enableControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = true;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }
        if (disbledControlIDS.indexOf(con.ID) > -1) {
          con.IS_Dependent_Enabled = false;
          if (con.CONTROL == "4")
            this.UpdateParentChildDetails(con);
        }

      });
    }
    else {
      this.UpdateParentChildDetails(question);
    }

    if (makeNull == "Y") {
      this.staticformFields.forEach((con) => {
        if (con.IS_Dependent_Display == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Display == true) {

        }
        if (con.IS_Dependent_Enabled == false) {
          con.ControlValue = "";
          if (con.CONTROL == "10") {
            con.ControlValue = [];
          }
          if (con.CONTROL == "8") {
            con.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            });
          }
          if (con.CONTROL == "6") {
            con.SourceItems.forEach((item) => {
              item.Checked = false;
            });
          }
        }
        if (con.IS_Dependent_Enabled == true) {

        }
      });
    }
  }

  UpdateParentChildDetails(question: any) {
    if (question.Control_Condtions == null || question.Control_Condtions == undefined) {
      question.Control_Condtions = [];
    }
    let displayControlIDS = [];
    let hideControlIDS = [];
    let enableControlIDS = [];
    let disbledControlIDS = [];

    question.Control_Condtions.forEach((item) => {
      item.ConditionsList.forEach((otemCon) => {
        switch (otemCon.Mapped_Condtion) {
          case "1": //display
            if (displayControlIDS.length == 0) {
              displayControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disCntrIds && disCntrIds.length > 0) {
                disCntrIds.forEach((id) => {
                  if (!displayControlIDS.includes(id)) {
                    displayControlIDS.push(id);
                  }
                })
              }
            }

            break;
          case "2": //enabled

            if (enableControlIDS.length == 0) {
              enableControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let enableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (enableCntrIds && enableCntrIds.length > 0) {
                enableCntrIds.forEach((id) => {
                  if (!enableControlIDS.includes(id)) {
                    enableControlIDS.push(id);
                  }
                })
              }
            }
            break;
          case "3": //hide

            if (hideControlIDS.length == 0) {
              hideControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let hideCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (hideCntrIds && hideCntrIds.length > 0) {
                hideCntrIds.forEach((id) => {
                  if (!hideControlIDS.includes(id)) {
                    hideControlIDS.push(id);
                  }
                })
              }
            }
            break;

          case "4": //disabled
            if (disbledControlIDS.length == 0) {
              disbledControlIDS = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
            }
            else {
              let disableCntrIds = otemCon.Mapped_Controls_List.map(function (a) { return a.ControlID; });
              if (disableCntrIds && disableCntrIds.length > 0) {
                disableCntrIds.forEach((id) => {
                  if (!disbledControlIDS.includes(id)) {
                    disbledControlIDS.push(id);
                  }
                })
              }
            }
            break;
        }
      });
    })

    this.staticformFields.forEach((con) => {
      if (displayControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = false;
      }
      if (hideControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Display = true;
      }
      if (enableControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = false;
      }
      if (disbledControlIDS.indexOf(con.ID) > -1) {
        con.IS_Dependent_Enabled = true;
      }
    });

  }
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  uploadchange(event, ques: SCREEN_CONTROL): void {
    let Flag = true;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      let file = event.target.files[i].name;
      let ext = file.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;

      if (file != null && ((filesize > 52428800) || (ext == 'exe'))) {
        Flag = false;
      }
      else {
        this.saveTempFiles(event.target.files[i]).subscribe((result: any) => {
          this.IsFormToched = true;
          let uploadFile = new Document_Upload_File();
          uploadFile.ID = result.Data[0].FileID;
          uploadFile.DOCUMENT_NAME = event.target.files[i].name;
          uploadFile.File = null;
          uploadFile.Status = "Add";
          uploadFile.UploadedDate = this.datepipe.transform(new Date().toUTCString(), 'dd-MMM-YYYY');
          let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
          if (hasValue.length > 0) {
            this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
          }
          else if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          } else {
            ques.UploadFiles.forEach((item) => {
              item.Status = "Delete";
            })
            ques.UploadFiles.push(uploadFile);
          }
        });

      }
    }
    if (!Flag)
      this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 50MB");
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;
    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControl = question.ControlValue;
      if (selectedControl != "" && selectedControl != undefined && selectedControl != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControl.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);

  }
  DeleteUpload(file, ques: SCREEN_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      this.commonService.CheckIsFileIsRefereancedInReviw(code).subscribe((x) => {
        if (x["Status"] == 2 && x["Data"] == false) {
          this.commonService.ValidationBanner(x["Message"]);
        }
        else {
          file.Status = "Delete";
        }
      });
    }
  }

  BindDataToStaticControls(MainObjData: any): any {
    for (var i = 0; i < this.staticformFields.length; i++) {
      switch (this.staticformFields[i].FIELD_CODE) {
        case "IS_UPTO_DATE":
          this.staticformFields[i].ControlValue = MainObjData.Data.IS_PROFILE_UPTO_DATE;
          break;
        case "SPON_DET_AGENDA":
          this.staticformFields[i].UploadFiles = MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_DET_AGENDA"
          });
          break;
        case "SPON_MITIGATE_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_MITIGATE_SPK"
          });
          break;
        case "SPON_FACULTY_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_FACULTY_SPK"
          });
          break;
        case "SPON_ACCREDITED_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_ACCREDITED_SPK"
          });
          break;
        case "SPON_EVALUATION_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_EVALUATION_SPK"
          });
          break;
        case "SPON_INVITATION_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_INVITATION_SPK"
          });
          break;
        case "SPON_NEEDS_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_NEEDS_SPK"
          });
          break;
        case "SPON_MEASURES_SPK":
          this.staticformFields[i].UploadFiles =  MainObjData.Data.UploadedDocuments.filter((item) => {
            return item.Filed_CodeExt == "SPON_MEASURES_SPK"
          });
          break;
      }

      if (this.staticformFields[i].CONTROL == '4') {
        this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
      }
    }
  }

  BindDataToDynamicControls() {
    if (this.applicationID != null && this.applicationID != undefined && this.applicationID != "") {
      let sr = new ScreenResponseModel();
      sr.Id = "SCR-034";
      sr.RowId = this.applicationID;
      sr.AppId = this.applicationID;
      this.summaryService.getGrantsScreenResponse(sr).subscribe(summary => {
        this.submittedresponse = summary;
        if (this.submittedresponse != null && this.submittedresponse.length > 0) {
          for (let i = 0; i < this.staticformFields.length; i++) {
            var response = this.submittedresponse.filter(x => x.SCREEN_CONTROL_ID == this.staticformFields[i].ID);

            if (response != null && response.length > 0) {
              if (this.staticformFields[i].CONTROL == '6') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                  var options = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(",");
                  if (this.staticformFields[i].SourceItems != null && this.staticformFields[i].SourceItems != undefined) {
                    for (let c = 0; c < this.staticformFields[i].SourceItems.length; c++) {
                      if (options.indexOf(this.staticformFields[i].SourceItems[c].value) > -1) {
                        this.staticformFields[i].SourceItems[c].Checked = true;
                      }
                      else {
                        this.staticformFields[i].SourceItems[c].Checked = false;
                      }
                    }
                  }

                }
              }
              else if (this.staticformFields[i].CONTROL == '10') {
                this.staticformFields[i].NotimesChanged = 0;
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "") {
                  this.staticformFields[i].ControlValue = [];

                  var options1 = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER.split(',');
                  options1.forEach((item) => {
                    this.staticformFields[i].ControlValue.push(item);
                  });
                  this.staticformFields[i].SUBFIELDNAME = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
                }
                else {
                  this.staticformFields[i].ControlValue = [];
                }
              }
              else if (this.staticformFields[i].CONTROL == '5') {
                if (response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != null && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != "" && response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER != undefined) {
                  let formd = new Date(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                  this.staticformFields[i].ControlValue = formd;

                  if (this.staticformFields[i].DATEFORMATE == 'DD-MMM-YYYY') {
                    let formd = this.commonService.getdisplayedDate(response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER);
                    this.staticformFields[i].ControlValue = formd;
                  }

                }

              }
              else {
                this.staticformFields[i].ControlValue = response[0].SCREEN_RESPONSE_ANSWER[0].ANSWER;
              }
              this.staticformFields[i].UploadFiles = response[0].UploadFiles;
              if (this.staticformFields[i].CONTROL == '4') {
                this.ApplyConditions({ value: this.staticformFields[i].ControlValue }, this.staticformFields[i], "N");
              }
            }

          }
        }

      });
    }
  }

  getScreenDataEdit(){
    let model = new DocumentModel();
    model.Featureid = this.FeatureID;
    model.Rowid = this.rowid;
    model.Appid = this.applicationID;
    this.summaryService.FetchProfileUptoDate(this.applicationID).subscribe((summary) => {
      if (summary != null && summary != undefined) {

        this.createdUser = summary.Data["CREATED_BY"];
        //this.permission = summary.Data["PERMISSION"];
        if(summary.Data["ID"] == null){
          this.submitStatus = true;
        }
        

        if(((this.user.ID != summary.Data["CREATED_BY"]) && summary.Data["SUBMIT_STATUS"] == 1 ) || (this.user.ID == summary.Data["CREATED_BY"]) || this.isSubmitVisible == false ){
          this.Id = summary.Data["ID"];
          this.BindDataToDynamicControls();
          this.BindDataToStaticControls(summary);
          this.ScreenSubmitStatus = summary.Data["SUBMIT_STATUS"] == 1 ? true : false;
          this.submitStatus = true;
      }
      else{
        this.submitStatus = summary.Data["SUBMIT_STATUS"] == 1 ? true : false;
      }
    
      if(this.Grantsapp?.STATUS > 1 && summary.Data["SUBMIT_STATUS"] == 1){
        this.disableSave = true;
      }

      if(!this.isSubmitVisible){
        this.disableSave = false;
      }
    } 

    });
  }

  SaveSponsorShip_GM_APP() {
    let uploadData = new FormData();
    uploadData.append("ScreenControlsData", JSON.stringify(this.GeneralInformationFields));
    uploadData.append("APPLICATION_TYPE_ID", this.Application_Type_ID);
    uploadData.append("SUBMIT_STATUS","0");
    return this.summaryService.SaveCMEGeneralInfo("api/GMAPPSponsorship/Insert", uploadData);
  }

  GetParentScreenFieldsConfigControls(screenCode: string)
  {
    this.commonService.GetScreenConfigControls(screenCode, this.applicationID, this.applicationID, (ScreenData) => {
      this.GeneralInformationFields = ScreenData["SCREEN_CONTROL"];
    });
  }

  onRadiobuttonChange(){
    this.IsFormToched = true;
  }


}
